import React from "react";
import ReactToPrint from "react-to-print";
import ConsentFormCoagulationandhemo from "../ConsentForms/ConsentFormCoagulationandhemo";
import ConsentFormCytopathologyRequis from "../ConsentForms/ConsentFormCytopathologyRequis";
import ConsentFormElectrophoresisRequ from "../ConsentForms/ConsentFormElectrophoresisRequ";
import ConsentFormforHIVTest from "../ConsentForms/ConsentFormforHIVTest";
import ConsentFormHistoConsent from "../ConsentForms/ConsentFormHistoConsent";
import ConsentFormMaternalScreen from "../ConsentForms/ConsentFormMaternalScreen";
import RequestFormMaternal from "../ConsentForms/RequestFormMaternal";
import ConsentFormFNAC from "../ConsentForms/ConsentFormFNAC";
import { jsPDF } from 'jspdf';


class ExportPdfComponent extends React.Component {
    render() {
        const pdfProps = this.props;
        const formName = pdfProps.formName;
        const formURL = pdfProps.formURL;
        console.log(formName);
        let patientName = pdfProps.PName;
        let age = pdfProps.Age;
        let gender = pdfProps.Gender;
        let refDoctor = pdfProps.RefDoctor;
        if (refDoctor === "") { refDoctor = "Self"; }
        if (gender === "1") { gender = "Male"; } else if (gender === "2") { gender = "Female"; } else { gender = "Other"; }
        const downloadImage = () => {
           window.open(formURL, '_blank');
        };
        return (
            <div>

                {
                    formName === "COAGULATION AND HEMO" ? <ConsentFormCoagulationandhemo PName={patientName} Age={age} Gender={gender} RefDoctor={refDoctor} ref={(response) => (this.componentRef = response)} />
                        : formName === "CONSENT FOR HIV TEST" ? <ConsentFormforHIVTest PName={patientName} Age={age} Gender={gender} RefDoctor={refDoctor} ref={(response) => (this.componentRef = response)} />
                            : formName === "CONSENT FORM  FNAC" ? <ConsentFormFNAC PName={patientName} Age={age} Gender={gender} RefDoctor={refDoctor} ref={(response) => (this.componentRef = response)} />
                                : formName === "CYTOPATHOLOGY REQUIS" ? <ConsentFormCytopathologyRequis PName={patientName} Age={age} Gender={gender} RefDoctor={refDoctor} ref={(response) => (this.componentRef = response)} />
                                    : formName === "ELECTROPHORESIS REQU" ? <ConsentFormElectrophoresisRequ PName={patientName} Age={age} Gender={gender} RefDoctor={refDoctor} ref={(response) => (this.componentRef = response)} />
                                        : formName === "HISTO CONCENT" ? <ConsentFormHistoConsent PName={patientName} Age={age} Gender={gender} RefDoctor={refDoctor} ref={(response) => (this.componentRef = response)} />
                                            : formName === "MATERNAL SCREEN" ? <ConsentFormMaternalScreen PName={patientName} Age={age} Gender={gender} RefDoctor={refDoctor} ref={(response) => (this.componentRef = response)} />
                                                // : null
                                                :
                                                <img src={formURL} alt={formName} style={{ maxWidth: '100%' }} />
                }
                {
                    formName === "COAGULATION AND HEMO" || formName === "CONSENT FOR HIV TEST" || formName === "CONSENT FORM  FNAC" || formName === "CYTOPATHOLOGY REQUIS" || formName === "ELECTROPHORESIS REQU" || formName === "HISTO CONCENT" || formName === "MATERNAL SCREEN" ?
                        <ReactToPrint content={() => this.componentRef} trigger={() => <button type="button" className="btn btn-primary">Print to PDF!</button>} />
                        :
                        <button type="button" className="btn btn-primary" onClick={downloadImage}>Print Image!</button>
                }
            </div>
        );
    }
}

export default React.memo(ExportPdfComponent);